import { IPersonalInformation } from 'types/IPersonalInformation';
import calculateAge from '_helpers/generic/DateTime';

const PERSONAL_INFORMATION: IPersonalInformation = {
  about:
    'A diligent and innovative Frontend Engineer with four years of hands-on experience developing dynamic and user-centric web applications. With a solid foundation in frontend development frameworks and a keen eye for design aesthetics, I aim to contribute my expertise to a forward-thinking team where I can continue to grow while making meaningful contributions to impactful projects.',
  basicInformation: {
    age: calculateAge('11/10/1998'),
    email: 'sherifelsaidy98@gmail.com',
    phone: '+20 1010 65 3252',
    address: '29 Shehab st., Mohandessin, Egypt',
    languages: ['Arabic', 'English', 'French'],
  },
};

export default PERSONAL_INFORMATION;
